"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var tv4 = require('tv4');

var ROLES = require('../../constant/core/roles.constant');

var Role = /*#__PURE__*/function () {
  function Role(opt) {
    _classCallCheck(this, Role);

    this.role = null;
    this.campusCode = null;
    this.tenantCode = null;
    this.groupIds = [];
    this.types = [];

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(Role, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.role = opt.role || null;
      this.campusCode = opt.campusCode || null;
      this.tenantCode = opt.tenantCode || null;
      this.groupIds = opt.groupIds || [];

      if (opt.groupId && !this.groupIds.includes(opt.groupId)) {
        // eslint-disable-next-line no-console
        console.warn('Warning!! groupId from Role object has been deprecated, use groupIds as an array of string');
        this.groupIds.push(opt.groupId);
      }

      this.types = opt.types ? opt.types : [];
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Role.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      var roleEnums = Object.keys(ROLES).map(function (role) {
        return ROLES[role];
      });
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'role.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          role: {
            "enum": roleEnums
          },
          campusCode: {
            type: ['string', 'null']
          },
          tenantCode: {
            type: ['string', 'null']
          },
          groupIds: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          groupName: {
            type: ['string', 'null']
          },
          types: {
            type: 'array',
            item: {
              type: 'string'
            }
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Role;
}();

module.exports = Role;